import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export default function DynamicToggleButton({ data, sx, onChange, value }) {
    return (
        <ToggleButtonGroup color="primary" size="small" value={value} exclusive onChange={onChange}>
            {data.map((item, index) => {
                return (
                    <ToggleButton
                        value={item.value}
                        key={index}
                        sx={{
                            borderRadius: '3px',
                            p: '2px',
                            width: '90px',
                            '&.Mui-selected': {
                                bgcolor: '#00647e',
                                color: 'white',
                            },
                            ...sx,
                        }}
                    >
                        {item.content}
                    </ToggleButton>
                );
            })}
        </ToggleButtonGroup>
    );
}
